export { default } from 'autobind-decorator';
